import React, { useState, useEffect } from 'react';
import Link from '../utils/link';
import { Logo, LogoSister } from '../components/icons';
import Fade from 'react-reveal/Fade';
import { useInView } from 'react-intersection-observer';
import layoutQuery from "../hooks/use-layout-query";
import NewsletterPopup from '../components/newsletter-form';
import NewsletterPopupSister from '../components/newsletter-form-sister';

const Footer = ({ site, handleLinkClick }) => {
  const data = layoutQuery();
  const [activeLink, setActiveLink] = useState(null);
  const [showNewsletterPopup, setShowNewsletterPopup] = useState(false);
  const [fadePopup, setFadePopup] = useState(false); // New state for fade effect
  const siteName = site || 'studio-ashby';

  const handleLinkClickHandler = (link) => {
    setActiveLink(link);
    handleLinkClick(link);
  };

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const handleSubscribeClick = (e) => {
    e.preventDefault();
    setFadePopup(true); // Start fade-in effect
    setShowNewsletterPopup(true);
  };

  const handleClosePopup = () => {
    localStorage.setItem('newsletterModalShown', 'true'); // Add this line
    setFadePopup(false);
    setTimeout(() => {
      setShowNewsletterPopup(false);
    }, 300);
  };
  
  useEffect(() => {
    // Only set the timer if the newsletter modal hasn't been shown before
    if (!localStorage.getItem('newsletterModalShown')) {
      const timer = setTimeout(() => {
        setFadePopup(true);
        setShowNewsletterPopup(true);
      }, 10000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <NewsletterPopup 
        showModal={showNewsletterPopup}
        show={showNewsletterPopup} 
        hidePopup={handleClosePopup}
        fadePopup={fadePopup} // Pass fade state for CSS class
      />

      {siteName !== 'sister' ? (
        <footer ref={ref} className={`site--${siteName} footer`}>
          <Fade distance='30px' bottom>
              <div className='footer__inner'>
                <div className='footer__col'>
                  <div className="logo">
                    <Link to='/' title='Studio Ashby' className='footer__logo'
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClickHandler('/');
                      }}
                    >
                      <Logo color='#AE9891'/>
                    </Link>
                  </div>
                </div>
                <div className='footer__col'>
                  <nav>
                    <ul>
                      <li>
                        <Link 
                          to='/contact'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/contact/');
                          }}
                        >Contact</Link>
                      </li>
                      {/* <li>
                        <Link 
                          to='/services'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/services/');
                          }}
                        >Services</Link>
                      </li> */}
                      <li>
                        <Link to='https://www.instagram.com/studioashby'>Instagram</Link>
                      </li>
                      <li>
                        <Link 
                          to='/careers'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/careers/');
                          }}
                        >Careers</Link>
                      </li>
                      <li>
                        {/* <Link onClick={handleSubscribeClick}>Subscribe</Link> */}


                          <Link
                          to='/newsletter'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/newsletter/');
                          }}
                        >Newsletter</Link>
                      </li>
                      <li>
                        <Link
                          to='/privacy-policy'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/privacy-policy/');
                          }}
                        >Privacy Policy</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className='footer__col'>
                  <p className='copyright'>
                    &copy; {new Date().getFullYear()} Studio Ashby<br/>
                    Site by <Link to='https://studiosmall.com'>StudioSmall</Link>
                  </p>
                </div>
              </div>
          </Fade>
        </footer>
      ) : (
        <footer ref={ref} className={`site--${siteName} footer`}>
          <Fade distance='30px' bottom>
              <div className='footer__inner'>
                <div className='footer__col'>
                  <p className='copyright'>
                    &copy; {new Date().getFullYear()} Studio Ashby<br/>
                    Site by <Link to='https://studiosmall.com'>StudioSmall</Link>
                  </p>
                </div>
                <div className='footer__col'>
                  <nav>
                    <ul className='footer__main-nav'>
                      <li>
                        <Link
                          to='/sister/contact/'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/contact/');
                          }}
                        >Contact</Link>
                      </li>
                      <li>
                        <Link
                          to='/sister/trade'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/trade');
                          }}
                        >Trade</Link>
                      </li>
                      <li>
                        <Link
                          to='/sister/stockists'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/stockists');
                          }}
                        >Stockists</Link>
                      </li>
                      <li>
                        <Link
                          to='/careers'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/careers/');
                          }}
                        >Careers</Link>
                      </li>
                      <li>
                        <Link to='https://www.instagram.com/sisterbystudioashby'>Instagram</Link>
                      </li>
                    </ul>
                    <ul className='footer__secondary-nav'>
                      <li>
                        {/* <Link onClick={handleSubscribeClick}>Subscribe</Link> */}

                          <Link
                          to='/newsletter'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/newsletter/');
                          }}
                        >Newsletter</Link>
                      </li>
                      <li>
                        <Link
                          to='/sister/terms-and-conditions/'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/terms-and-conditions/');
                          }}
                        >Terms & Conditions</Link>
                      </li>
                      {/* Pinterest's Merchant Guidelines require an easy-to-find
                          returns policy. The wording lives under "Returns, Refunds
                          & Exchanges" in the terms, so link straight at it. */}
                      <li>
                        <Link
                          to='/sister/delivery-returns/'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/delivery-returns/');
                          }}
                        >Delivery & Returns</Link>
                      </li>
                      <li>
                        <Link
                          to='/sister/privacy-policy/'
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClickHandler('/sister/privacy-policy/');
                          }}
                        >Privacy Policy</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className='footer__col'>
                  <div className="logo__sister">
                    <Link
                      title='Sister by Studio Ashby' className='footer__logo'
                      to='/sister/' 
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClickHandler('/sister/');
                      }}
                    >
                      <LogoSister color='#ffffff'/>
                    </Link>
                  </div>
                </div>
              </div>
          </Fade>
        </footer>
      )}
    </>
  );
}

export default Footer;
